import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store/Hooks";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import {
    Button, Col, Flex, Form, Row, Select, Skeleton, message, DatePicker,
    Space,
    Spin
} from "antd";
import { SFModal } from "../../components/elements/SFModal";
import { SyncOutlined, WindowsOutlined } from '@ant-design/icons';
import { PdfIcon } from "../../components/common/CustomIcons";
import { toast } from "react-toastify";
import _ from "lodash";
import { enmPdfExportType } from "../../models/enums/PdfExportType";
import { nanoid } from "@reduxjs/toolkit";
import { HotelSelect } from "../../components/common/HotelSelect";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { ExportModal } from "../../components/common/ExportModal";
import { mdlReservationEntryItem } from "../../models/domain/ReservationEntryItem";
import { enmExportStatus } from "../../models/enums/ExportStatus";
import { ActionService } from "../../services/ActionService";
import { enmPriceType } from "../../models/enums/PriceType";
import { enmActionType } from "../../models/enums/ActionType";
import { ActionReportTable } from "../../components/action/ActionReportTable";
import dayjs from "dayjs";
import { enmExportModalType } from "../../models/enums/ExportModalType";
import { SpoAgencySelect } from "../../components/common/SpoAgencySelect";
import { SpoRoomTypeSelect } from "../../components/common/SpoRoomTypeSelect";
import { SpoMarketSelect } from "../../components/common/SpoMarketSelect";
import { mdlHotel } from "../../models/domain/Hotel";
import { mdlSpoReportParams } from "../../models/domain/value-objects/SpoReportParams";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DateRangePicker } from "../../components/common/DateRangePicker";
import { enmExcelExportType } from "../../utils/ExcelColumnMappings";

dayjs.extend(utc);
dayjs.extend(timezone);

const dateFormats = ['DD.MM.YYYY', 'DD/MM/YYYY'];
export const ActionReports = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const store = useAppSelector(x => x.site);
    const [openExcelExportModal, setOpenExcelExportModal] = useState<boolean>(false);
    const [openPdfExportModal, setOpenPdfExportModal] = useState<boolean>(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const dateFormat = 'DD.MM.YYYY';
    const { RangePicker } = DatePicker;
    const [params, setParams] = useState<mdlSpoReportParams>();
    const [selectedHotelIds, setSelectedHotelIds] = useState<string[]>();
    const [selectedHotelNames, setSelectedHotelNames] = useState<string[]>();

    const { mutateAsync: getActionReports, isLoading, data } = useMutation(
        (params: mdlSpoReportParams) => ActionService.Report({ data: params }),
        {
            onMutate(variables) {
                // if (variables.sendDateObj)
                //     variables.sendDate = variables.sendDateObj;
                // if (variables.sendDateEndObj)
                //     variables.sendDateEnd = variables.sendDateEndObj;
                // if (variables.accomEndDateObj)
                //     variables.accomEndDate = variables.accomEndDateObj;
                // if (variables.accomStartDateObj)
                //     variables.accomStartDate = variables.accomStartDateObj;
                // variables.accomEndDate = dayjs(variables.accomEndDateObj).format("DD.MM.YYYY");
                // variables.accomStartDate = dayjs(variables.accomStartDateObj).format("DD.MM.YYYY");
                // variables.readDateEnd = dayjs(variables.readDateEndObj).format("DD.MM.YYYY");
                // variables.readedDate = dayjs(variables.readedDateObj).format("DD.MM.YYYY");
                // variables.sellStartDate = dayjs(variables.sellStartDateObj).format("DD.MM.YYYY");
                // variables.sellEndDate = dayjs(variables.sellEndDateObj).format("DD.MM.YYYY");
                variables.localName = selectedHotelNames;
                setParams(variables);
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && !data.header.success) {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            }
        }
    );
    //#endregion

    //#region HELPERS 
    const exportToPDF = (type: enmPdfExportType, entryList: Array<mdlReservationEntryItem>) => {
        // var exportProps: mdlPDFRendererProps = {
        //     params: { reservationEntryList: entryList },
        //     rendererType: enmPdfRendererType.EntryList,
        //     type: type
        // }
        // dispatch(setPdfExportObject(exportProps));
    }
    //#endregion


    const handleHotelChange = (hotels: mdlHotel[]) => {
        setSelectedHotelIds(hotels.map(x => x.id));
        setSelectedHotelNames(hotels.map(x => x.localName!));
    }

    const formSetter = (name: string, value: string[]) => {
        form.setFieldValue(name, value);
    }

    return (
        <>
            {contextHolder}
            <div className="nk-content ">
                <div className="container-fluid">
                    <Spin spinning={store.exportStatus != enmExportStatus.DONE}>
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="nk-block">
                                    <div className="row g-gs">
                                        <div className="col-12">
                                            <div className="card card-bordered">
                                                <div className="card-inner">
                                                    {
                                                        <Flex vertical>
                                                            <Form
                                                                form={form}
                                                                key={nanoid()}
                                                                name="action-filter-form"
                                                                layout="vertical"
                                                                onFinish={async (variables) => await getActionReports(variables)}
                                                                autoComplete="off"
                                                            >
                                                                <Row gutter={16}>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.hotelIds")}
                                                                            name="localName"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <HotelSelect sendObject={true} mode={"multiple"} onChange={handleHotelChange} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item name="sendDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item name="sendDateEnd" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.sendDate")}
                                                                        >
                                                                            <DateRangePicker
                                                                                id={"send-date"}
                                                                                fromValue={
                                                                                    params?.sendDate ? dayjs(params.sendDate) : undefined}
                                                                                toValue={
                                                                                    params?.sendDateEnd ? dayjs(params.sendDateEnd) : undefined
                                                                                }
                                                                                onChange={(dates) => {
                                                                                    if (dates) {
                                                                                        form.setFieldsValue({
                                                                                            sendDate: dates[0],
                                                                                            sendDateEnd: dates[1]
                                                                                        });
                                                                                    } else {
                                                                                        form.setFieldsValue({
                                                                                            sendDate: null,
                                                                                            sendDateEnd: null,
                                                                                        });
                                                                                    }

                                                                                }}
                                                                                placeholder={[t("entryList.startDate"), t("entryList.endDate")]}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.agencies")}
                                                                            name="agencyName"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <SpoAgencySelect formSetter={formSetter} defaultAllSelected={true} mode="multiple" hotelIds={selectedHotelIds} />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item name="sellStartDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item name="sellEndDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.saleDate")}
                                                                        >
                                                                            <DateRangePicker
                                                                                id={nanoid()}
                                                                                fromValue={
                                                                                    params?.sellStartDate ? dayjs(params.sellStartDate) : undefined}
                                                                                toValue={
                                                                                    params?.sellEndDate ? dayjs(params.sellEndDate) : undefined
                                                                                }
                                                                                onChange={(dates) => {
                                                                                    if (dates) {
                                                                                        form.setFieldsValue({
                                                                                            sellStartDate: dates[0],
                                                                                            sellEndDate: dates[1]
                                                                                        });
                                                                                    } else {
                                                                                        form.setFieldsValue({
                                                                                            sellStartDate: null,
                                                                                            sellEndDate: null,
                                                                                        });
                                                                                    }

                                                                                }}
                                                                                placeholder={[t("entryList.startDate"), t("entryList.endDate")]}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.roomType")}
                                                                            name="roomType"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <SpoRoomTypeSelect formSetter={formSetter} defaultAllSelected={true} hotelIds={selectedHotelIds} mode="multiple" />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item name="readedDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item name="readDateEnd" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.readDate")}
                                                                        >
                                                                            <DateRangePicker
                                                                                id={nanoid()}
                                                                                fromValue={
                                                                                    params?.readedDate ? dayjs(params.readedDate) : undefined}
                                                                                toValue={
                                                                                    params?.readDateEnd ? dayjs(params.readDateEnd) : undefined
                                                                                }
                                                                                onChange={(dates) => {
                                                                                    if (dates) {
                                                                                        form.setFieldsValue({
                                                                                            readedDate: dates[0],
                                                                                            readDateEnd: dates[1]
                                                                                        });
                                                                                    } else {
                                                                                        form.setFieldsValue({
                                                                                            readedDate: null,
                                                                                            readDateEnd: null,
                                                                                        });
                                                                                    }

                                                                                }}
                                                                                placeholder={[t("entryList.startDate"), t("entryList.endDate")]}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.markets")}
                                                                            name="market"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <SpoMarketSelect defaultAllSelected={true} formSetter={formSetter} hotelIds={selectedHotelIds} mode="multiple" />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={6}>
                                                                        <Form.Item name="accomStartDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item name="accomEndDate" hidden>
                                                                            <DatePicker />
                                                                        </Form.Item>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.accomDate")}
                                                                        >
                                                                            <DateRangePicker
                                                                                id={nanoid()}
                                                                                fromValue={
                                                                                    params?.accomStartDate ? dayjs(params.accomStartDate) : undefined}
                                                                                toValue={
                                                                                    params?.accomEndDate ? dayjs(params.accomEndDate) : undefined
                                                                                }
                                                                                onChange={(dates) => {
                                                                                    if (dates) {
                                                                                        form.setFieldsValue({
                                                                                            accomStartDate: dates[0],
                                                                                            accomEndDate: dates[1]
                                                                                        });
                                                                                    } else {
                                                                                        form.setFieldsValue({
                                                                                            accomStartDate: null,
                                                                                            accomEndDate: null,
                                                                                        });
                                                                                    }

                                                                                }}
                                                                                placeholder={[t("entryList.startDate"), t("entryList.endDate")]}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.priceType")}
                                                                            name="priceType"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <Select
                                                                                size="large"
                                                                                filterOption={(input, option) =>
                                                                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                                                }
                                                                                options={
                                                                                    [
                                                                                        { label: t("action.report.perPerson"), value: enmPriceType.PER_PERSON.toString() },
                                                                                        { label: t("action.report.perRoom"), value: enmPriceType.PER_ROOM.toString() },
                                                                                    ]
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col span={4}>
                                                                        <Form.Item<mdlSpoReportParams>
                                                                            label={t("action.report.spoType")}
                                                                            name="spoType"
                                                                            rules={[{ required: true, message: t("common.required") }]}
                                                                        >
                                                                            <Select
                                                                                size="large"
                                                                                filterOption={(input, option) =>
                                                                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                                                                }
                                                                                options={
                                                                                    [
                                                                                        { label: t("action.report.spoTypeAccomBased"), value: enmActionType.ACCOM_BASED.toString() },
                                                                                        { label: t("action.report.spoTypeEntryBased"), value: enmActionType.ENTRY_BASED.toString() },
                                                                                    ]
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                                <Row >
                                                                    <Form.Item style={{ width: "100%" }}>
                                                                        <Flex align={"center"} justify="flex-end">
                                                                            <Space>
                                                                                <Button type="primary" htmlType="submit" icon={<SyncOutlined />} size="middle">
                                                                                    {t("common.search")}
                                                                                </Button>
                                                                                {
                                                                                    data && data.body && data.body.data
                                                                                    &&
                                                                                    <>
                                                                                        <Button type="primary" onClick={() => setOpenPdfExportModal(true)} icon={<PdfIcon />} size="middle">
                                                                                            {t("action.report.exportToPDF")}
                                                                                        </Button>
                                                                                        <Button type="primary" onClick={() => setOpenExcelExportModal(true)} icon={<WindowsOutlined />}>{t("common.exportToExcel")}</Button>
                                                                                    </>
                                                                                }
                                                                            </Space>
                                                                        </Flex>
                                                                    </Form.Item>
                                                                </Row>
                                                            </Form>
                                                        </Flex>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                isLoading
                                                &&
                                                <div className="row g-gs">
                                                    <div className="col-12">
                                                        <div className="card card-bordered">
                                                            <div className="card-inner">
                                                                <>
                                                                    <Skeleton active />
                                                                    <Skeleton active />
                                                                    <Skeleton active />
                                                                </>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {
                                                data && data.body && data.body.data
                                                &&
                                                <>
                                                    <div className="row g-gs">
                                                        <div className="col-12">
                                                            <div className="card card-bordered">
                                                                <div className="card-inner">
                                                                    <ActionReportTable
                                                                        dataSource={data.body.data} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </div>
            </div>
            <SFModal
                width={window.innerWidth * 60 / 100}
                open={openExcelExportModal}
                toggler={() => { setOpenExcelExportModal(!openExcelExportModal) }}
                body={<ExportModal excelExportType={enmExcelExportType.ActionReport} type={enmExportModalType.Excel} name="actionReport" data={data?.body?.data} fnModalClose={() => setOpenExcelExportModal(!openExcelExportModal)} />}
                title={t("common.exportToExcel")}
            />
            <SFModal
                width={window.innerWidth * 60 / 100}
                open={openPdfExportModal}
                toggler={() => { setOpenPdfExportModal(!openPdfExportModal) }}
                body={<ExportModal excelExportType={enmExcelExportType.ActionReport} name="actionReport" type={enmExportModalType.PDFTable} data={data?.body?.data} fnModalClose={() => setOpenPdfExportModal(!openPdfExportModal)} />}
                title={t("common.exportToExcel")}
            />
        </>

    );
};
